import { DescriptionOutlinedIcon, Flex, Text } from '@shared/components';

type NoQuestionInLocationOverlayVariant = 'no-location-selected' | 'no-question';

export interface NoQuestionInLocationOverlayProps {
  variant: NoQuestionInLocationOverlayVariant;
}

function getOverlayByVariant(variant: NoQuestionInLocationOverlayVariant) {
  switch (variant) {
    case 'no-question':
      return (
        <>
          <DescriptionOutlinedIcon
            sx={{
              color: (theme) => theme.palette.grey[400],
            }}
          />
          <Text
            variant='captionSemibold'
            sx={{
              color: (theme) => theme.palette.text.disabled,
            }}
          >
            ไม่มีคำถามใน Location นี้
          </Text>
        </>
      );
    case 'no-location-selected':
      return (
        <Text
          variant='captionSemibold'
          sx={{
            color: (theme) => theme.palette.text.disabled,
          }}
        >
          เลือก Location เพื่อดูคำถามในคลัง
        </Text>
      );
  }
}

export default function NoQuestionInLocationOverlay(
  props: Readonly<NoQuestionInLocationOverlayProps>,
) {
  const { variant } = props;

  return (
    <Flex
      sx={(theme) => ({
        py: theme.spacing(4),
        borderRadius: theme.shape.rounded(2),
        background: theme.palette.grey[50],
        justifyContent: 'center',
      })}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: (theme) => theme.spacing(2),
        }}
      >
        {getOverlayByVariant(variant)}
      </Flex>
    </Flex>
  );
}
